module.exports = __webpack_public_path__ + "img/2019-04-15.ffd75a75.jpg";